import { render } from "./NewsRoomDetails.html?vue&type=template&id=ce602756&scoped=true&ts=true&external"
import script from "./NewsRoomDetails.ts?vue&type=script&lang=ts&external"
export * from "./NewsRoomDetails.ts?vue&type=script&lang=ts&external"

import "./NewsRoomDetails.scss?vue&type=style&index=0&id=ce602756&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce602756"]])

export default __exports__